
































import Vue from 'vue';
import Component from 'vue-class-component';
import { TeamModel } from '@/models/team.model';
import {
  authModule,
  challengeModule,
  teamModule,
  teamsState
} from '@/utils/store-acessor';
import TeamCard from '@/components/Shared/TeamCard.vue';
import { ChallengeModel } from '@/models/challenge.model';
import ListScaffold from '@/components/Shared/ListScaffold.vue';

@Component({
  components: {
    ListScaffold,
    TeamCard
  },
  beforeRouteLeave: (to, from, next) => {
    teamsState.teamLoaded(null);
    next();
  }
})
export default class ChallengeTeams extends Vue {
  @teamModule.Getter('teams') teams!: TeamModel[];
  @challengeModule.Getter('selectedChallenge')
  challenge!: ChallengeModel | null;
  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;

  async mounted() {
    if (this.challenge?.id) {
      await teamsState.fetchTeams(this.challenge.id);
    }
  }

  onTeamSelected(team: TeamModel) {
    if (team.slug) {
      this.$router.push({
        name: 'show-team-members',
        params: { teamSlug: team.slug }
      });
    }
  }

  onSendInvitation(team: TeamModel) {
    if (this.challenge?.id && team.id) {
      teamsState.sendInvitation({
        teamId: team.id,
        challengeId: this.challenge.id
      });
    }
  }

  onEditTeam(team: TeamModel) {
    if (team.slug) {
      this.$router.push({
        name: 'edit-challenge-team',
        params: { teamSlug: team.slug }
      });
    }
  }

  onDestroyTeam(team: TeamModel) {
    if (this.challenge?.id && team.id) {
      teamsState.deleteTeam({
        challengeId: this.challenge.id,
        teamId: team.id
      });
    }
  }
}
